import { useContext } from 'react';
import { ComposerPrefillContext } from '../providers/ComposerPrefillProvider';

/**
 * useComposerPrefill — read/write the one-shot composer-prefill slot.
 *
 * Returns `{ pending, prefill, consume }`:
 *   - pending: string | null    — the handle to prefill, or null
 *   - prefill(handle): void     — request a prefill (e.g. from MembersPanel)
 *   - consume(): void           — clear the slot (Composer calls this after
 *                                  it has applied the prefill)
 *
 * Returns a safe no-op shape when used outside a ComposerPrefillProvider so
 * the Composer can mount in test contexts without the provider.
 */
export function useComposerPrefill() {
  const ctx = useContext(ComposerPrefillContext);
  if (!ctx) {
    return { pending: null, prefill: () => {}, consume: () => {} };
  }
  return ctx;
}

export default useComposerPrefill;
